import React from 'react';
import styled from 'styled-components';
import StyledIcon from '../../../styledComponents/styles/Icon.styled';
import { ButtonMediumOpenSans } from '../../../styledComponents/styles/Buttons.styled';
import { LEARN_MORE_URL } from '../../../shared/helpers/ViaDefaults';

const Card = styled.div`
  background: rgba(255, 255, 255, 0.95);
  border: 2px solid #FFFFFF;
  border-radius: 5px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  height: 215px;
  padding: 26px 29px;
  width: 354px;
`;

const CardTitle = styled.div`
  color: #373737;
  font-family: Open Sans, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0;
  text-align: left;
`;

const CardDescription = styled.div`
  color: #373737;
  font-family: Open Sans, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 16px;
  padding: 17px 0 20px 0;
  
  span {
    font-style: italic;
  }
`;

export default function LearnMoreCard() {
  const LearnMoreLink = () => {
    window.open(LEARN_MORE_URL, '_blank');
  }

  return (
    <Card>
      <CardTitle>
        Powering Global Experiences to Change our World
      </CardTitle>
      <CardDescription>
        At <span>Via</span> TRM, we believe global citizens positively change the world we live in.
        Plan your next adventure in <span>Via</span>!
      </CardDescription>
      <ButtonMediumOpenSans
        aria-label="Learn more"
        onClick={LearnMoreLink}
      >
        {'Learn more '}<StyledIcon type={'ChevronForward'} size={'18px'} />
      </ButtonMediumOpenSans>
    </Card>
  );
}